import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

const secureUrls = environment.secureUrls;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Add token to secure URLs, but exclude auth endpoints that don't need authentication
    const isAuthEndpoint = req.url.includes('/auth/actions/');
    const shouldAddToken = secureUrls.some((url) => req.url.startsWith(url)) && !isAuthEndpoint;
    let authReq = req;
    let token: string | null;

    // For WorkOS authkit, we need to use the id_token as auth for requests
    if (shouldAddToken) {
        const session = authService.getCurrentSession();
        token = session?.idToken || null;
        if (token) {
            authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        } else {
            // No valid session, redirect to login instead of making the request
            router.navigate([environment.loginPath]);
            return throwError(() => 'No valid session');
        }
    }

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && !req.url.includes('/auth/actions/refresh')) {
                return handle401Error(authReq, next, authService, router);
            }
            if (error.status === 403) {
                router.navigate([environment.authErrorPath]);
                return throwError(() => error);
            }
            return throwError(() => error);
        })
    );
};

function handle401Error(request: HttpRequest<unknown>, next: any, authService: AuthService, router: Router): Observable<any> {
    return throwError(() => Error(`401 Exception when calling the ${request.url} endpoint`));
}
